(function () {
  'use strict';
  var qr = document.getElementById('rdc-qr');
  if (!qr) return;

  var KEY_PENDING = 'rdc-degustacion-pendiente';
  var KEY_DONE = 'rdc-degustacion-completado';
  var params = new URLSearchParams(window.location.search);
  var success = qr.querySelector('[data-qr-success]');

  function open(locked) {
    qr.hidden = false;
    if (locked) qr.classList.add('rdc-qr--locked');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    qr.hidden = true;
    document.body.style.overflow = '';
  }

  if (success) {
    /* Registro completado: liberar bloqueo, recordarlo para siempre y mostrar confirmación */
    try {
      localStorage.removeItem(KEY_PENDING);
      localStorage.setItem(KEY_DONE, '1');
    } catch (e) {}
    open(false);

    var timeEl = qr.querySelector('[data-qr-time]');
    var dateEl = qr.querySelector('[data-qr-date]');
    function tick() {
      var now = new Date();
      if (timeEl) timeEl.textContent = now.toLocaleTimeString('es-CO');
      if (dateEl) dateEl.textContent = now.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' });
    }
    tick();
    setInterval(tick, 1000);
  } else {
    var alreadyDone = false;
    var pending = false;
    try {
      alreadyDone = localStorage.getItem(KEY_DONE) === '1';
      pending = localStorage.getItem(KEY_PENDING) === '1';
    } catch (e) {}

    /* Si ya se registró antes en este dispositivo, nunca se le vuelve a exigir el formulario,
       aunque entre de nuevo por el mismo link con ?degustacion=1 */
    if (!alreadyDone && (params.has('degustacion') || pending)) {
      try { localStorage.setItem(KEY_PENDING, '1'); } catch (e) {}
      open(true); /* obligatorio: sin cerrar hasta registrarse */
    }
  }

  qr.addEventListener('click', function (ev) {
    var closer = ev.target.closest('[data-qr-close]');
    if (closer && !qr.classList.contains('rdc-qr--locked')) {
      if (closer.getAttribute('href')) { close(); return; }
      ev.preventDefault();
      close();
    }
  });
})();